import React from 'react'

const Offers = () => {
  return (
    <div>
    <h1>Lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit rerum quaerat nemo, eaque fugit, ducimus minima quia explicabo obcaecati repellendus molestiae quae voluptatem officia sit sint ipsum, sunt consectetur! Recusandae iste rerum assumenda non ad iure nesciunt, vero sint cumque!</h1>
    </div>
  )
}

export default Offers